import index from './pages/index/index.vue';
import stepOne from './pages/pc/stepOne.vue'
import stepTwo from './pages/pc/stepTwo.vue'
import stepThree from './pages/pc/stepThree.vue'
import stepFour from './pages/pc/stepFour.vue'
import stepMoOne from './pages/mobile/stepOne.vue'
import stepMoTwo from './pages/mobile/stepTwo.vue'
import stepMoThree from './pages/mobile/stepThree.vue'
import stepMoFour from './pages/mobile/stepFour.vue'
export default {
    routes: [
        {
            path: '/',
            component: index
        },{
            path: '/stepMoOne',
            component: stepMoOne
        },{
            path: '/stepMoTwo',
            component: stepMoTwo
        },{
            path: '/stepMoThree',
            component: stepMoThree
        },{
            path: '/stepMoFour',
            component: stepMoFour
        },{
            path: '/stepOne',
            component: stepOne
        },{
            path: '/stepTwo',
            component: stepTwo
        },{
            path: '/stepThree',
            component: stepThree
        },{
            path: '/stepFour',
            component: stepFour
        }
    ]
};



// WEBPACK FOOTER //
// ./src/router.js